import { colors } from '../../colors';
var button = {
  //Hero button
  linkColorHero: colors.smoke,
  linkColorHeroHover: colors.white,
  backgroundColorHero: colors.salmon,
  backgroundColorHoverHero: colors.wine,
  borderRadiusHero: '0',
  linkLineHeightHero: '30px',
  heroButtonPadding: '20px 35px',
  //primary button
  linkColorPrimary: colors.smoke,
  linkColorPrimaryHover: colors.white,
  backgroundColorPrimary: colors.salmon,
  backgroundColorHoverPrimary: colors.wine,
  borderRadiusPrimary: '0',
  //secondary button
  linkColorSecondary: colors.white,
  backgroundColorSecondary: colors.darkSage,
  backgroundColorHoverSecondary: colors.wine,
  borderRadiusSecondary: '0',
  linkColorSecondaryHover: colors.white,
  borderColorSecondary: 'transparent',
  borderColorSecondaryHover: 'transparent'
};
export default button;